'use strict';

let setRequiredOnTouch = function() {
	$('.form-control:required').on('blur keydown', function() {
		// Going to need to go through many different validations
		// to do client-side validation. Including password used in data-breaches.
		// also, what about if there are multiple validation requirements on the html? Then what?
		let inputName = $(this).attr('name');
		let validationInputName = '.' + inputName + '-validation';

		if($(this)[0].value === '') {
			// required value is empty
			$(this).addClass('is-invalid');
			$(this).removeClass('is-valid');
			$(validationInputName).remove();
			$(this).after('<div class="invalid-feedback ' + inputName + '-validation">This field is required</div>');
		} else {
			$(this).addClass('is-valid');
			$(this).removeClass('is-invalid');
			$(validationInputName).remove();
			$(this).after('<div class="valid-feedback ' + inputName + '-validation">Looks good!</div>');
		}
	});
};

let init = function() {
	setRequiredOnTouch();

	$('.searchbar .search-label').on('click', function(e) {
		e.preventDefault();
		$(this).parent().toggleClass('collapsed');
	});

	$('#example-indeterminate-checkbox').prop('indeterminate', true);
};

module.exports =  {
	init: init
};
